import React from 'react'
import styled from 'styled-components'
import { Chart } from 'react-charts'
import { Trophy } from 'app/icons'
import Stack from 'shared/content-control/Stack'

export const ScoreChart = ({
  startedGame: { players, numberOfRounds, isRoundComplete },
}) => {
  // Order players by user alphabetically so username' colors match chart colors
  const sortedPlayers = sortPlayers(players)

  const data = React.useMemo(
    () =>
      sortedPlayers.map(({ username, score, isGameWinner }) => {
        let totals = 0
        const label = isGameWinner ? <Trophy>{username}</Trophy> : username
        return {
          label,
          data: [
            [0, 0],
            ...new Array(numberOfRounds).fill().map((itm, index) => {
              if (score[index] === undefined) return [index + 1, null]
              totals = totals + score[index]
              return [index + 1, totals]
            }),
          ],
        }
      }),
    [sortedPlayers, numberOfRounds]
  )

  const axes = React.useMemo(
    () => [
      { primary: true, type: 'ordinal', position: 'bottom' },
      { type: 'linear', position: 'right' },
    ],
    []
  )

  return (
    <Stack space={1}>
      <ChartWrapper
        style={{
          position: 'relative',
          maxWidth: `${numberOfRounds * 4}rem`,
          minWidth: '10rem',
          margin: 'auto',
        }}
      >
        <Chart data={data} axes={axes} tooltip />
      </ChartWrapper>
      <Key players={players} isRoundComplete={isRoundComplete} />
    </Stack>
  )
}

const ChartWrapper = styled.div`
  width: 100%;
  height: 10rem;

  /*  Chart label styling override */
  .tickLabel {
    fill: white !important;
  }
`

const sortPlayers = ({ home, away }) =>
  [home, ...away].sort((a, b) => a.id.localeCompare(b.id))

// Shows a colored label to help user identif
export const Key = ({ players, isRoundComplete }) => {
  const sortedPlayers = sortPlayers(players)
  return (
    <div>
      {sortedPlayers.map(({ username, score }, index) => {
        const lastScore = score.slice(-1)
        const sign = lastScore > 0 ? '+' : lastScore < 0 ? '-' : ''
        const appendScore = isRoundComplete ? ` ${sign}${lastScore}` : ''
        return (
          <span key={username}>
            <KeyLabel style={{ backgroundColor: playersColors[index] }}>
              {username}
              {appendScore}
            </KeyLabel>
            &nbsp;&nbsp;
          </span>
        )
      })}
    </div>
  )
}

const KeyLabel = styled.span`
  border-radius: 0.4rem;
  color: white;
  padding: 0.2rem;
`

const playersColors = [
  '#4ab5eb',
  '#fc6868',
  '#decf3f',
  '#60bd68',
  '#faa43a',
  '#c63b89',
]
